import React from 'react';
import {
  Button,
  Col,
  Form,
  FormControl,
  InputGroup,
  Modal,
  Row,
} from 'react-bootstrap';

export default function AskCustomerNameAndApproveOrderModal(props) {
  const {
    enterNameShow,
    setEnterNameShow,
    customerName,
    setCustomerName,
    approveOrder,
    tableCode,
  } = props;
  return (
    <Modal show={enterNameShow} onHide={() => setEnterNameShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa fa-shopping-cart"></i>&nbsp;Sipariş kimin adına
          olacak?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col></Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>
            <span className="text-danger">Lütfen bir ad giriniz!</span>
          </Form.Label>

          <InputGroup>
            <FormControl
              type="text"
              value={customerName}
              onChange={(e) => {
                setCustomerName(e.target.value);
              }}
              placeholder="Adınız..."
              aria-label="Adınız"
            ></FormControl>
            <Button
              variant="primary"
              onClick={() => {
                setEnterNameShow(false);
                approveOrder(tableCode, customerName);
              }}
            >
              Siparişi Onayla
            </Button>
          </InputGroup>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}
